import {ComponentData} from "../../engine/tools/EntityManager";

export class PumpPressure implements ComponentData {

    position:number = 0
    pressure: number = 0
    lastPressure: number = 0
    timeSinceLastPump: number = 0

    constructor(options?: Partial<PumpPressure>) {
        Object.assign(this, options)
    }
}


